
(function(){
  function qs(sel,root){return (root||document).querySelector(sel)}
  function qsa(sel,root){return Array.prototype.slice.call((root||document).querySelectorAll(sel))}
  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-menu-toggle]'); if(t){qs('.mobile-menu')?.classList.toggle('open')}
    var s=e.target.closest('[data-search-toggle]'); if(s){qs('.search-bar')?.classList.toggle('open'); setTimeout(function(){qs('.search-bar input')?.focus()},10)}
    var arrow=e.target.closest('[data-marquee-arrow]'); if(arrow){var shell=arrow.closest('.marquee-shell'), viewport=qs('.marquee-viewport',shell); if(viewport){var dir=arrow.getAttribute('data-marquee-arrow')==='next'?1:-1; viewport.scrollBy({left:dir*(viewport.clientWidth*.8),behavior:'smooth'});}}
    var add=e.target.closest('[data-ajax-add]'); if(add){e.preventDefault(); var id=add.getAttribute('data-variant-id'); if(!id){return} add.disabled=true; add.textContent='Adding...'; fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:Number(id),quantity:Number(add.getAttribute('data-qty')||1)})}).then(function(r){if(!r.ok){throw new Error('Add failed')} return r.json()}).then(function(){return fetch('/cart.js')}).then(function(r){return r.json()}).then(function(cart){qsa('[data-cart-count]').forEach(function(el){el.textContent=cart.item_count; el.style.display=cart.item_count>0?'grid':'none'}); add.textContent='Added ✓'; if(location.pathname.indexOf('/cart')===0){return fetch('/cart?updated='+Date.now()).then(function(r){return r.text()}).then(function(html){var doc=new DOMParser().parseFromString(html,'text/html'); var fresh=doc.querySelector('.cart-wrap'); var current=document.querySelector('.cart-wrap'); if(fresh&&current){current.replaceWith(fresh)}else{location.reload()}})} setTimeout(function(){add.textContent=add.getAttribute('data-label')||'Quick add'; add.disabled=false},1200)}).catch(function(){add.textContent='Error'; setTimeout(function(){add.textContent=add.getAttribute('data-label')||'Quick add'; add.disabled=false},1200)})}
    var buy=e.target.closest('[data-buy-now]'); if(buy){e.preventDefault(); var id=buy.getAttribute('data-variant-id'); if(id) window.location.href='/cart/'+id+':1?checkout';}
  });

  // Auto-scroll marquee, with the same duplicated-track wrap logic as the React version.
  qsa('[data-auto-marquee]').forEach(function(viewport){
    var speed=Number(viewport.getAttribute('data-speed')||50); var acc=viewport.scrollLeft; var last=performance.now(); var paused=false;
    viewport.addEventListener('mouseenter',function(){paused=true}); viewport.addEventListener('mouseleave',function(){paused=false});
    viewport.addEventListener('touchstart',function(){paused=true},{passive:true}); viewport.addEventListener('touchend',function(){setTimeout(function(){paused=false},1200)},{passive:true});
    function tick(now){var dt=(now-last)/1000; last=now; var half=viewport.scrollWidth/2; if(!paused && half>0){acc += speed*dt; if(acc>=half) acc-=half; viewport.scrollLeft=Math.round(acc);} else {acc=viewport.scrollLeft;} requestAnimationFrame(tick)}
    requestAnimationFrame(tick);
  });

  // Hijabs filter from querystring and buttons.
  function setFilter(slug){
    qsa('[data-product-card]').forEach(function(card){var a=card.getAttribute('data-anime')||''; card.classList.toggle('hidden-by-filter', slug && a!==slug)});
    qsa('[data-filter-btn]').forEach(function(btn){btn.classList.toggle('active',(btn.getAttribute('data-filter-btn')||'')===slug)});
    var count=qsa('[data-product-card]:not(.hidden-by-filter)').length; var c=qs('[data-filter-count]'); if(c)c.textContent=count+' '+(count===1?'product':'products');
  }
  qsa('[data-filter-btn]').forEach(function(btn){btn.addEventListener('click',function(){var slug=btn.getAttribute('data-filter-btn')||''; var url=new URL(window.location.href); if(slug){url.searchParams.set('anime',slug)}else{url.searchParams.delete('anime')} history.replaceState(null,'',url.toString()); setFilter(slug);})});
  var params=new URLSearchParams(location.search); if(qs('[data-filter-grid]')) setFilter(params.get('anime')||'');

  // Quantity +/- on product page.
  qsa('[data-qty-wrap]').forEach(function(w){var input=qs('input',w); qsa('button',w).forEach(function(b){b.addEventListener('click',function(){var n=Number(input.value||1)+(b.getAttribute('data-qty-action')==='plus'?1:-1); input.value=Math.max(1,n);})})});
})();

(function(){
  function qsa(sel,root){return Array.prototype.slice.call((root||document).querySelectorAll(sel))}
  qsa('[data-promo-rotator]').forEach(function(rotator){
    var slides=qsa('span',rotator), i=0;
    if(slides.length<2)return;
    setInterval(function(){slides[i].classList.remove('active');i=(i+1)%slides.length;slides[i].classList.add('active')},2800);
  });
  function pad(n){return String(n).padStart(2,'0')}

function getActiveShopifyCurrency() {
  return (
    window.Shopify &&
    Shopify.currency &&
    Shopify.currency.active
  ) || 'GBP';
}

function getShopifyCurrencyRate() {
  var rate =
    window.Shopify &&
    Shopify.currency &&
    Number(Shopify.currency.rate);

  if (!rate || rate <= 0) {
    return 1;
  }

  return rate;
}

function formatThemeMoney(cents) {
  var currency = getActiveShopifyCurrency();

  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currency
    }).format(Number(cents || 0) / 100);
  } catch (error) {
    return (
      (Number(cents || 0) / 100).toFixed(2) +
      ' ' +
      currency
    );
  }
}

function convertGbpPromotionalMoney() {
  var currency = getActiveShopifyCurrency();
  var rate = getShopifyCurrencyRate();

  qsa('[data-gbp-money-converted]').forEach(function(element) {
    var baseGbpPence = Number(
      element.getAttribute('data-gbp-pence') || 0
    );

    var convertedPence;

    if (currency === 'GBP') {
      convertedPence = baseGbpPence;
    } else {
      convertedPence = Math.round(baseGbpPence * rate);
    }

    element.textContent = formatThemeMoney(convertedPence);
  });
}

convertGbpPromotionalMoney();

  function expireDailyDealPrices(endEpoch) {
    qsa('[data-tobari-daily-deal-price="true"]').forEach(function(price) {
      var priceEnd = Number(price.getAttribute('data-tobari-deal-end-epoch') || 0);
      if (priceEnd && priceEnd !== endEpoch) return;

      var regularPrice = Number(price.getAttribute('data-tobari-regular-price') || 0);
      price.classList.remove('tobari-price--sale');
      price.removeAttribute('data-tobari-daily-deal-price');
      price.innerHTML = '<span class="tobari-price__current">' + formatThemeMoney(regularPrice) + '</span>';
    });

    qsa('[data-tobari-daily-deal-active="true"]').forEach(function(node) {
      var nodeEnd = Number(node.getAttribute('data-tobari-deal-end-epoch') || 0);
      if (!nodeEnd || nodeEnd === endEpoch) {
        node.setAttribute('data-tobari-daily-deal-active', 'false');
      }
    });

    qsa('[data-tobari-daily-deal-badge="true"]').forEach(function(badge) {
      var badgeEnd = Number(badge.getAttribute('data-tobari-deal-end-epoch') || 0);
      if (!badgeEnd || badgeEnd === endEpoch) {
        badge.remove();
      }
    });
  }

  qsa('[data-launch-countdown]').forEach(function(box){
    var launch=new Date(box.getAttribute('data-launch-at')).getTime();
    var days=box.querySelector('[data-countdown-days]'), hours=box.querySelector('[data-countdown-hours]'), minutes=box.querySelector('[data-countdown-minutes]'), seconds=box.querySelector('[data-countdown-seconds]');
    var line=box.querySelector('.launch-line');
    function tick(){
      var diff=Math.max(0,launch-Date.now());
      if(diff===0){ if(line) line.innerHTML='<strong>Now Live</strong>'; }
      var d=Math.floor(diff/(1000*60*60*24));
      var h=Math.floor(diff/(1000*60*60)%24);
      var m=Math.floor(diff/(1000*60)%60);
      var s=Math.floor(diff/1000%60);
      if(days)days.textContent=pad(d); if(hours)hours.textContent=pad(h); if(minutes)minutes.textContent=pad(m); if(seconds)seconds.textContent=pad(s);
    }
    tick(); setInterval(tick,1000);
  });

function getTimeZoneParts(date, timeZone) {
  var parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23'
  }).formatToParts(date);

  var result = {};

  parts.forEach(function(part) {
    if (part.type !== 'literal') {
      result[part.type] = Number(part.value);
    }
  });

  return result;
}

function getTimeZoneOffsetMs(timestamp, timeZone) {
  var parts = getTimeZoneParts(new Date(timestamp), timeZone);

  var timeShownAsUtc = Date.UTC(
    parts.year,
    parts.month - 1,
    parts.day,
    parts.hour,
    parts.minute,
    parts.second
  );

  return timeShownAsUtc - Math.floor(timestamp / 1000) * 1000;
}

function zonedDateTimeToUtc(
  year,
  month,
  day,
  hour,
  minute,
  second,
  timeZone
) {
  var desiredTimeAsUtc = Date.UTC(
    year,
    month - 1,
    day,
    hour,
    minute,
    second
  );

  var timestamp = desiredTimeAsUtc;

  for (var i = 0; i < 4; i++) {
    timestamp =
      desiredTimeAsUtc -
      getTimeZoneOffsetMs(timestamp, timeZone);
  }

  return timestamp;
}

function getNextMidnightInTimeZone(timeZone) {
  var nowParts = getTimeZoneParts(new Date(), timeZone);

  var nextCalendarDate = new Date(
    Date.UTC(
      nowParts.year,
      nowParts.month - 1,
      nowParts.day + 1
    )
  );

  return zonedDateTimeToUtc(
    nextCalendarDate.getUTCFullYear(),
    nextCalendarDate.getUTCMonth() + 1,
    nextCalendarDate.getUTCDate(),
    0,
    0,
    0,
    timeZone
  );
}

qsa('[data-midnight-deal-countdown]').forEach(function(box) {
  var timeZone =
    box.getAttribute('data-deal-time-zone') ||
    'Europe/London';

  var end = getNextMidnightInTimeZone(timeZone);

  var days = box.querySelector('[data-countdown-days]');
  var hours = box.querySelector('[data-countdown-hours]');
  var minutes = box.querySelector('[data-countdown-minutes]');
  var seconds = box.querySelector('[data-countdown-seconds]');

  var timerId = null;
  var reloadStarted = false;

  function updateNumber(element, value) {
    if (element) {
      element.textContent = pad(value);
    }
  }

  function tick() {
    var difference = end - Date.now();

    if (difference <= 0) {
      updateNumber(days, 0);
      updateNumber(hours, 0);
      updateNumber(minutes, 0);
      updateNumber(seconds, 0);

      if (timerId) {
        window.clearInterval(timerId);
      }

      if (!reloadStarted) {
        reloadStarted = true;

        window.setTimeout(function() {
          window.location.reload();
        }, 1500);
      }

      return;
    }

    var remainingDays = Math.floor(
      difference / (1000 * 60 * 60 * 24)
    );

    var remainingHours = Math.floor(
      difference / (1000 * 60 * 60) % 24
    );

    var remainingMinutes = Math.floor(
      difference / (1000 * 60) % 60
    );

    var remainingSeconds = Math.floor(
      difference / 1000 % 60
    );

    updateNumber(days, remainingDays);
    updateNumber(hours, remainingHours);
    updateNumber(minutes, remainingMinutes);
    updateNumber(seconds, remainingSeconds);
  }

  tick();

  timerId = window.setInterval(tick, 1000);
});

  qsa('[data-tobari-daily-deal-price="true"]').forEach(function(price) {
    var endEpoch = Number(price.getAttribute('data-tobari-deal-end-epoch') || 0);
    if (endEpoch && endEpoch * 1000 <= Date.now()) {
      expireDailyDealPrices(endEpoch);
    }
  });
})();


/* product page carousel */
(function() {
  function initTobariCarousel(root) {
    root = root || document;
    var viewports = root.querySelectorAll('[data-tobari-auto-marquee]');
    viewports.forEach(function(viewport) {
      if (viewport.dataset.tobariCarouselReady === 'true') return;
      viewport.dataset.tobariCarouselReady = 'true';

      var speed = Number(viewport.getAttribute('data-speed') || 50);
      var pos = viewport.scrollLeft || 0;
      var last = performance.now();
      var paused = false;
      var interactingUntil = 0;

      function half() { return viewport.scrollWidth / 2; }
      function firstStep() {
        var track = viewport.firstElementChild;
        var card = track && track.firstElementChild;
        var next = card && card.nextElementSibling;
        if (card && next) return next.offsetLeft - card.offsetLeft;
        if (card) return card.offsetWidth + 24;
        return 320;
      }
      function normalize() {
        var h = half();
        if (!h) return;
        if (viewport.scrollLeft >= h) viewport.scrollLeft -= h;
        else if (viewport.scrollLeft <= 1) viewport.scrollLeft += h;
        pos = viewport.scrollLeft;
      }

      viewport.addEventListener('mouseenter', function() { paused = true; });
      viewport.addEventListener('mouseleave', function() { paused = false; interactingUntil = 0; });
      viewport.addEventListener('touchstart', function() { interactingUntil = performance.now() + 1500; }, { passive: true });
      viewport.addEventListener('touchend', function() { interactingUntil = performance.now() + 800; }, { passive: true });
      viewport.addEventListener('scroll', normalize, { passive: true });

      var shell = viewport.closest('.tobari-marquee-shell');
      if (shell) {
        shell.querySelectorAll('[data-tobari-arrow]').forEach(function(btn) {
          btn.addEventListener('click', function() {
            var dir = btn.getAttribute('data-tobari-arrow') === 'next' ? 1 : -1;
            var h = half();
            if (h > 0) {
              if (dir === 1 && viewport.scrollLeft >= h) viewport.scrollLeft -= h;
              if (dir === -1 && viewport.scrollLeft < firstStep()) viewport.scrollLeft += h;
            }
            interactingUntil = performance.now() + 1200;
            var target = viewport.scrollLeft + dir * firstStep();
            pos = target;
            viewport.scrollTo({ left: target, behavior: 'smooth' });
          });
        });
      }

      function tick(now) {
        var dt = Math.min((now - last) / 1000, 0.033);
        last = now;
        var h = half();
        if (!paused && now >= interactingUntil && h > 0) {
          pos += speed * dt;
          if (pos >= h) pos -= h;
          else if (pos < 0) pos += h;
          viewport.scrollLeft = Math.round(pos);
        } else {
          pos = viewport.scrollLeft;
        }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);

      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(normalize);
        ro.observe(viewport);
        if (viewport.firstElementChild) ro.observe(viewport.firstElementChild);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function() { initTobariCarousel(document); });
  document.addEventListener('shopify:section:load', function(event) { initTobariCarousel(event.target); });
  initTobariCarousel(document);
})();

// cart fucntionality 
// (function () {
//   async function getCart() {
//     const response = await fetch('/cart.js', {
//       headers: { Accept: 'application/json' }
//     });

//     if (!response.ok) throw new Error('Could not fetch cart');

//     return response.json();
//   }

//   function updateCartCounts(cart) {
//     document.querySelectorAll('[data-cart-count]').forEach((count) => {
//       count.textContent = cart.item_count > 99 ? '99+' : cart.item_count;
//       count.style.display = cart.item_count > 0 ? 'grid' : 'none';
//     });
//   }

//   async function refreshCartHtml() {
//     const response = await fetch('/cart?updated=' + Date.now(), {
//       headers: { Accept: 'text/html' }
//     });

//     if (!response.ok) throw new Error('Could not refresh cart');

//     const html = await response.text();
//     const doc = new DOMParser().parseFromString(html, 'text/html');

//     const freshCart = doc.querySelector('[data-cart-live-wrap]');
//     const currentCart = document.querySelector('[data-cart-live-wrap]');

//     if (freshCart && currentCart) {
//       currentCart.replaceWith(freshCart);
//       setTimeout(autoAddPremiumBoxIfUnlocked, 150);
//     }
//   }

//   async function changeCartLine(line, quantity) {
//     const response = await fetch('/cart/change.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         Accept: 'application/json'
//       },
//       body: JSON.stringify({
//         line: Number(line),
//         quantity: Math.max(0, Number(quantity))
//       })
//     });

//     if (!response.ok) throw new Error('Could not update cart');

//     const cart = await response.json();
//     updateCartCounts(cart);
//     await refreshCartHtml();
//   }

//   async function addVariantToCart(variantId, quantity) {
//     const response = await fetch('/cart/add.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         Accept: 'application/json'
//       },
//       body: JSON.stringify({
//         id: Number(variantId),
//         quantity: Number(quantity || 1)
//       })
//     });

//     if (!response.ok) throw new Error('Could not add item');

//     const cart = await getCart();
//     updateCartCounts(cart);
//     await refreshCartHtml();
//   }

//   async function autoAddPremiumBoxIfUnlocked() {
//     const trigger = document.querySelector('[data-auto-add-premium-box="true"]');
//     if (!trigger) return;

//     const variantId = trigger.getAttribute('data-premium-box-variant-id');
//     if (!variantId) return;

//     trigger.removeAttribute('data-auto-add-premium-box');

//     try {
//       await addVariantToCart(variantId, 1);
//     } catch (error) {
//       console.error(error);
//     }
//   }

//   document.addEventListener('click', async function (event) {
//     const changeButton = event.target.closest('[data-cart-change]');
//     if (changeButton) {
//       event.preventDefault();

//       const line = changeButton.getAttribute('data-line');
//       const quantity = changeButton.getAttribute('data-quantity');

//       changeButton.disabled = true;

//       try {
//         await changeCartLine(line, quantity);
//       } catch (error) {
//         console.error(error);
//         changeButton.disabled = false;
//       }

//       return;
//     }

//     const premiumButton = event.target.closest('[data-cart-add-premium]');
//     if (premiumButton) {
//       event.preventDefault();

//       const variantId = premiumButton.getAttribute('data-variant-id');
//       if (!variantId) return;

//       premiumButton.disabled = true;
//       premiumButton.textContent = 'Adding...';

//       try {
//         await addVariantToCart(variantId, 1);
//       } catch (error) {
//         console.error(error);
//         premiumButton.textContent = 'Error';

//         setTimeout(() => {
//           premiumButton.textContent = 'Add premium packaging';
//           premiumButton.disabled = false;
//         }, 1200);
//       }
//     }
//   });

//   document.addEventListener('DOMContentLoaded', autoAddPremiumBoxIfUnlocked);
//   autoAddPremiumBoxIfUnlocked();
// })();

// async function limitPremiumBoxToOne() {
//   const cartWrap = document.querySelector('[data-limit-premium-box="true"]');
//   if (!cartWrap) return;

//   const line = cartWrap.getAttribute('data-premium-box-line');
//   if (!line) return;

//   try {
//     await fetch('/cart/change.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         Accept: 'application/json'
//       },
//       body: JSON.stringify({
//         line: Number(line),
//         quantity: 1
//       })
//     });

//     const response = await fetch('/cart?updated=' + Date.now());
//     const html = await response.text();
//     const doc = new DOMParser().parseFromString(html, 'text/html');

//     const freshCart = doc.querySelector('[data-cart-live-wrap]');
//     const currentCart = document.querySelector('[data-cart-live-wrap]');

//     if (freshCart && currentCart) {
//       currentCart.replaceWith(freshCart);
//     }
//   } catch (error) {
//     console.error('Could not limit premium box to one', error);
//   }
// }

// document.addEventListener('DOMContentLoaded', limitPremiumBoxToOne);
// limitPremiumBoxToOne();

(function () {
  'use strict';

  var SLOT_SELECTOR = '[data-tobari-deal-slot-v4]';
  var COUNTDOWN_SELECTOR = '[data-tobari-midnight-countdown-v4]';

  var FIRST_WAIT_CHECK_MS = 60 * 1000;
  var LATER_WAIT_CHECK_MS = 5 * 60 * 1000;

  function pad2(value) {
    return String(value).padStart(2, '0');
  }

  function getTimeZoneParts(date, timeZone) {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(date);

    var result = {};

    parts.forEach(function (part) {
      if (part.type !== 'literal') {
        result[part.type] = Number(part.value);
      }
    });

    return result;
  }

  function getDateInTimeZone(date, timeZone) {
    var parts = getTimeZoneParts(date, timeZone);

    return (
      String(parts.year) +
      '-' +
      pad2(parts.month) +
      '-' +
      pad2(parts.day)
    );
  }

  function getTimeZoneOffsetMs(timestamp, timeZone) {
    var parts = getTimeZoneParts(new Date(timestamp), timeZone);

    var displayedAsUtc = Date.UTC(
      parts.year,
      parts.month - 1,
      parts.day,
      parts.hour,
      parts.minute,
      parts.second
    );

    return displayedAsUtc - Math.floor(timestamp / 1000) * 1000;
  }

  function zonedDateTimeToUtc(
    year,
    month,
    day,
    hour,
    minute,
    second,
    timeZone
  ) {
    var desiredAsUtc = Date.UTC(
      year,
      month - 1,
      day,
      hour,
      minute,
      second
    );

    var timestamp = desiredAsUtc;

    for (var index = 0; index < 4; index += 1) {
      timestamp =
        desiredAsUtc -
        getTimeZoneOffsetMs(timestamp, timeZone);
    }

    return timestamp;
  }

  function getNextMidnight(timeZone) {
    var nowParts = getTimeZoneParts(new Date(), timeZone);

    var nextDate = new Date(
      Date.UTC(
        nowParts.year,
        nowParts.month - 1,
        nowParts.day + 1
      )
    );

    return zonedDateTimeToUtc(
      nextDate.getUTCFullYear(),
      nextDate.getUTCMonth() + 1,
      nextDate.getUTCDate(),
      0,
      0,
      0,
      timeZone
    );
  }

  function renderWaitingState(slot) {
    if (!slot) return;

    slot.setAttribute('data-tobari-deal-status', 'waiting');
    slot.setAttribute('data-tobari-deal-date', '');
    slot.setAttribute('data-tobari-deal-handle', '');

    slot.innerHTML =
      '<div class="hero-countdown hero-daily-deal hero-daily-deal--waiting" data-tobari-deal-waiting-v4>' +
        '<div class="container-luxe countdown-inner">' +
          '<p class="launch-line hero-deal-copy">' +
            '<strong>Today’s Hijab Deal is being prepared…</strong>' +
          '</p>' +
          '<div class="countdown-units" aria-live="polite" aria-label="Today’s hijab deal is being prepared">' +
            '<span class="deal-ends-label">' +
              'Check back shortly — this updates automatically' +
            '</span>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function clearSlotTimer(slot) {
    if (slot && slot.tobariDealCheckTimer) {
      window.clearTimeout(slot.tobariDealCheckTimer);
      slot.tobariDealCheckTimer = null;
    }
  }

  function scheduleDealCheck(slot, delay) {
    if (!slot) return;

    clearSlotTimer(slot);

    slot.tobariDealCheckTimer = window.setTimeout(
      function () {
        refreshDealSection(slot);
      },
      delay
    );
  }

  function refreshDealSection(slot) {
    if (!slot || slot.tobariRefreshRunning === true) {
      return;
    }

    var sectionId = slot.getAttribute(
      'data-tobari-section-id'
    );

    if (!sectionId) {
      scheduleDealCheck(slot, LATER_WAIT_CHECK_MS);
      return;
    }

    slot.tobariRefreshRunning = true;

    var requestUrl = new URL(window.location.href);

    requestUrl.searchParams.set('sections', sectionId);
    requestUrl.searchParams.set(
      '_tobari_deal_refresh',
      String(Date.now())
    );

    fetch(requestUrl.toString(), {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      },
      cache: 'no-store'
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Daily deal section request failed.'
          );
        }

        return response.json();
      })
      .then(function (sections) {
        var sectionHtml = sections[sectionId];

        if (!sectionHtml) {
          throw new Error(
            'Shopify returned no hero section HTML.'
          );
        }

        var parsedDocument =
          new DOMParser().parseFromString(
            sectionHtml,
            'text/html'
          );

        var freshSlot =
          parsedDocument.querySelector(SLOT_SELECTOR);

        if (!freshSlot) {
          throw new Error(
            'The refreshed daily-deal slot was not found.'
          );
        }

        var freshStatus =
          freshSlot.getAttribute(
            'data-tobari-deal-status'
          );

        var freshDealDate =
          freshSlot.getAttribute(
            'data-tobari-deal-date'
          ) || '';

        var freshDealHandle =
          freshSlot.getAttribute(
            'data-tobari-deal-handle'
          ) || '';

        var londonToday = getDateInTimeZone(
          new Date(),
          'Europe/London'
        );

        slot.tobariRefreshRunning = false;
        clearSlotTimer(slot);

        if (
          freshStatus === 'active' &&
          freshDealDate === londonToday &&
          freshDealHandle
        ) {
          slot.replaceWith(freshSlot);
          initialiseDealSlot(freshSlot);

          window.setTimeout(function () {
            window.location.reload();
          }, 300);

          return;
        }

        slot.replaceWith(freshSlot);
        renderWaitingState(freshSlot);

        scheduleDealCheck(
          freshSlot,
          LATER_WAIT_CHECK_MS
        );
      })
      .catch(function (error) {
        slot.tobariRefreshRunning = false;

        scheduleDealCheck(
          slot,
          LATER_WAIT_CHECK_MS
        );

        console.warn(
          'Tobari daily deal refresh:',
          error
        );
      });
  }

  function initialiseCountdown(slot, countdown) {
    if (
      countdown.getAttribute(
        'data-tobari-countdown-ready'
      ) === 'true'
    ) {
      return;
    }

    countdown.setAttribute(
      'data-tobari-countdown-ready',
      'true'
    );

    var timeZone =
      countdown.getAttribute(
        'data-deal-time-zone'
      ) || 'Europe/London';

    var dealDate =
      countdown.getAttribute(
        'data-deal-date'
      ) || '';

    var today = getDateInTimeZone(
      new Date(),
      timeZone
    );

    if (!dealDate || dealDate !== today) {
      renderWaitingState(slot);
      scheduleDealCheck(slot, FIRST_WAIT_CHECK_MS);
      return;
    }

    var endTime = getNextMidnight(timeZone);

    var days = countdown.querySelector(
      '[data-countdown-days]'
    );

    var hours = countdown.querySelector(
      '[data-countdown-hours]'
    );

    var minutes = countdown.querySelector(
      '[data-countdown-minutes]'
    );

    var seconds = countdown.querySelector(
      '[data-countdown-seconds]'
    );

    var intervalId = null;
    var midnightHandled = false;

    function updateNumber(element, value) {
      if (element) {
        element.textContent = pad2(value);
      }
    }

    function tick() {
      var remaining = endTime - Date.now();

      if (remaining <= 0) {
        updateNumber(days, 0);
        updateNumber(hours, 0);
        updateNumber(minutes, 0);
        updateNumber(seconds, 0);

        if (intervalId) {
          window.clearInterval(intervalId);
        }

        if (!midnightHandled) {
          midnightHandled = true;
          renderWaitingState(slot);

          scheduleDealCheck(
            slot,
            FIRST_WAIT_CHECK_MS
          );
        }

        return;
      }

      updateNumber(
        days,
        Math.floor(
          remaining / (1000 * 60 * 60 * 24)
        )
      );

      updateNumber(
        hours,
        Math.floor(
          remaining / (1000 * 60 * 60) % 24
        )
      );

      updateNumber(
        minutes,
        Math.floor(
          remaining / (1000 * 60) % 60
        )
      );

      updateNumber(
        seconds,
        Math.floor(
          remaining / 1000 % 60
        )
      );
    }

    tick();

    intervalId = window.setInterval(tick, 1000);
  }

  function initialiseDealSlot(slot) {
    if (!slot) return;

    var status = slot.getAttribute(
      'data-tobari-deal-status'
    );

    var countdown = slot.querySelector(
      COUNTDOWN_SELECTOR
    );

    if (status === 'active' && countdown) {
      initialiseCountdown(slot, countdown);
      return;
    }

    renderWaitingState(slot);

    scheduleDealCheck(
      slot,
      FIRST_WAIT_CHECK_MS
    );
  }

  function initialiseAllDealSlots() {
    document
      .querySelectorAll(SLOT_SELECTOR)
      .forEach(function (slot) {
        initialiseDealSlot(slot);
      });
  }

  function refreshVisibleWaitingSlots() {
    if (document.hidden) return;

    document
      .querySelectorAll(SLOT_SELECTOR)
      .forEach(function (slot) {
        if (
          slot.getAttribute(
            'data-tobari-deal-status'
          ) === 'waiting'
        ) {
          clearSlotTimer(slot);
          refreshDealSection(slot);
        }
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialiseAllDealSlots
    );
  } else {
    initialiseAllDealSlots();
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      event.target
        .querySelectorAll(SLOT_SELECTOR)
        .forEach(function (slot) {
          initialiseDealSlot(slot);
        });
    }
  );

  document.addEventListener(
    'visibilitychange',
    refreshVisibleWaitingSlots
  );

  window.addEventListener(
    'focus',
    refreshVisibleWaitingSlots
  );
})();

(function () {
  'use strict';

  var RESTOCK_SELECTOR = '[data-tobari-restock-countdown]';

  function pad2(value) {
    return String(value).padStart(2, '0');
  }

  function getTimeZoneParts(date, timeZone) {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(date);

    var result = {};

    parts.forEach(function (part) {
      if (part.type !== 'literal') {
        result[part.type] = Number(part.value);
      }
    });

    return result;
  }

  function getTimeZoneOffsetMs(timestamp, timeZone) {
    var parts = getTimeZoneParts(new Date(timestamp), timeZone);
    var displayedAsUtc = Date.UTC(
      parts.year,
      parts.month - 1,
      parts.day,
      parts.hour,
      parts.minute,
      parts.second
    );

    return displayedAsUtc - Math.floor(timestamp / 1000) * 1000;
  }

  function zonedDateTimeToUtc(year, month, day, hour, timeZone) {
    var desiredAsUtc = Date.UTC(year, month - 1, day, hour, 0, 0);
    var timestamp = desiredAsUtc;

    for (var index = 0; index < 4; index += 1) {
      timestamp = desiredAsUtc - getTimeZoneOffsetMs(timestamp, timeZone);
    }

    return timestamp;
  }

  function getRestockTarget(dateValue, timeZone) {
    var match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateValue);

    if (!match) return NaN;

    return zonedDateTimeToUtc(
      Number(match[1]),
      Number(match[2]),
      Number(match[3]),
      0,
      timeZone
    );
  }

  function initialiseRestockCountdown(bar) {
    if (!bar || bar.getAttribute('data-tobari-restock-ready') === 'true') {
      return;
    }

    var dateValue = bar.getAttribute('data-restock-date') || '';
    var timeZone = bar.getAttribute('data-restock-time-zone') || 'Europe/London';
    var target = getRestockTarget(dateValue, timeZone);

    if (!Number.isFinite(target)) {
      bar.hidden = true;
      return;
    }

    bar.setAttribute('data-tobari-restock-ready', 'true');

    var days = bar.querySelector('[data-restock-days]');
    var hours = bar.querySelector('[data-restock-hours]');
    var minutes = bar.querySelector('[data-restock-minutes]');
    var seconds = bar.querySelector('[data-restock-seconds]');
    var intervalId = null;
    var wasCounting = false;

    function updateNumber(element, value) {
      if (element) element.textContent = pad2(value);
    }

    function tick() {
      var remaining = target - Date.now();

      if (remaining <= 0) {
        if (intervalId) window.clearInterval(intervalId);
        // Tobari animations: if someone watched it reach zero, show "Out now" with a petal burst.
        if (wasCounting && window.TobariMotion && document.body.classList.contains('tb-a-flip')) {
          window.TobariMotion.dropLive(bar);
        } else {
          bar.remove();
        }
        return;
      }
      wasCounting = true;

      updateNumber(days, Math.floor(remaining / 86400000));
      updateNumber(hours, Math.floor(remaining / 3600000) % 24);
      updateNumber(minutes, Math.floor(remaining / 60000) % 60);
      updateNumber(seconds, Math.floor(remaining / 1000) % 60);
    }

    tick();
    intervalId = window.setInterval(tick, 1000);
  }

  function initialiseAllRestockCountdowns(root) {
    (root || document)
      .querySelectorAll(RESTOCK_SELECTOR)
      .forEach(function (bar) {
        initialiseRestockCountdown(bar);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialiseAllRestockCountdowns(document);
    });
  } else {
    initialiseAllRestockCountdowns(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
      initialiseAllRestockCountdowns(event.target);
  });
})();

/* Pure display/reconciliation rules. Checkout discounts must independently validate eligibility. */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.TobariOfferRules = api;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';
  function evaluate(state) {
    const lines = state.lines || [];
    const paid = lines.filter(line => !line.gift && Number(line.price) > 0);
    const paidCount = paid.filter(line => line.hijab).reduce((n, line) => n + line.quantity, 0);
    const qty = id => id ? paid.filter(line => String(line.product) === String(id)).reduce((n, line) => n + line.quantity, 0) : 0;
    const boxAllowed = !!state.boxEnabled && paidCount >= Number(state.boxThreshold || 4);
    let freeBoxLeft = boxAllowed ? 1 : 0;
    const updates = {};

    // Returning customers: product IDs bought before (paid) and gifts already received.
    const idList = value => (Array.isArray(value) ? value : String(value || '').split(',')).map(String).filter(Boolean);
    const owned = new Set(idList(state.owned));
    const received = new Set(idList(state.received));

    // Bundles (Theme settings → Tobari bundles): one set of gifts per bundle per order.
    const bundles = (state.bundles || []).map(bundle => {
      const a = String(bundle.a || '');
      const b = String(bundle.b || '0') === '0' ? '' : String(bundle.b);
      const gifts = bundle.gifts || [];
      // A hijab bought in a past order completes a free-gift pair, once per customer:
      // at least one hijab must be in this cart, and not if they already got this pair's gifts.
      const giftsHad = gifts.length > 0 && gifts.every(gift => received.has(String(gift.product)));
      const pastOk = !!b && a !== b && gifts.length > 0 && !giftsHad;
      const pastA = pastOk && qty(a) === 0 && owned.has(a) && qty(b) > 0;
      const pastB = pastOk && !!b && qty(b) === 0 && owned.has(b) && qty(a) > 0;
      const haveA = qty(a) > 0 || pastA;
      const haveB = !b || qty(b) > 0 || pastB;
      // A bundle with any sold-out hijab or gift is switched off: no gifts are added, and any already added are removed.
      // Exception: the hijab a returning customer already owns may be sold out now.
      let live = bundle.live !== false;
      if (bundle.giftsOk !== undefined) {
        live = bundle.giftsOk !== false && (bundle.aOk !== false || pastA) && (!b || bundle.bOk !== false || pastB);
      }
      let ok = live && !!a && haveA && haveB;
      if (ok && b && a === b) ok = qty(a) >= 2;
      const left = {};
      gifts.forEach(gift => { left[String(gift.product)] = ok ? 1 : 0; });
      return { key: bundle.key, ok, gifts, left };
    });
    const giftProducts = new Set();
    bundles.forEach(bundle => bundle.gifts.forEach(gift => giftProducts.add(String(gift.product))));
    const isBundleKey = key => /^b\d+$/.test(String(key || ''));

    // 1. Gifts already marked for a bundle.
    for (const line of lines) {
      if (!isBundleKey(line.gift)) continue;
      const bundle = bundles.find(item => item.key === line.gift);
      const product = String(line.product);
      let wanted = 0;
      if (bundle && bundle.left[product] !== undefined && Number(line.price) === 0) {
        wanted = Math.min(line.quantity, bundle.left[product]);
        bundle.left[product] -= wanted;
      }
      if (wanted !== line.quantity) updates[line.key] = wanted;
    }
    // 2. Free gift products added another way (product page, old offers): keep only if a bundle earns them.
    for (const line of lines) {
      if (isBundleKey(line.gift) || line.gift === 'packaging') continue;
      if (String(line.variant) === String(state.freeBox) || String(line.variant) === String(state.paidBox)) continue;
      const product = String(line.product);
      if (!giftProducts.has(product) || Number(line.price) !== 0) continue;
      let wanted = 0;
      for (const bundle of bundles) {
        if (wanted >= line.quantity) break;
        const room = bundle.left[product] || 0;
        const take = Math.min(room, line.quantity - wanted);
        bundle.left[product] = room - take;
        wanted += take;
      }
      if (wanted !== line.quantity) updates[line.key] = wanted;
    }
    // 3. Gifts earned but not in the cart yet.
    const missingGifts = [];
    if (state.autoGift !== false) {
      for (const bundle of bundles) {
        if (!bundle.ok) continue;
        for (const gift of bundle.gifts) {
          if (gift.available && (bundle.left[String(gift.product)] || 0) > 0 && Number(gift.variant) > 0) {
            missingGifts.push({ id: Number(gift.variant), quantity: 1, properties: { _tobari_offer: bundle.key } });
          }
        }
      }
    }

    for (const line of lines) {
      if (String(line.variant) !== String(state.freeBox)) continue;
      const wanted = line.price === 0 ? Math.min(line.quantity, freeBoxLeft) : 0;
      freeBoxLeft -= wanted;
      if (wanted !== line.quantity) updates[line.key] = wanted;
    }
    const freeBoxPresent = lines.some(line => String(line.variant) === String(state.freeBox) && (updates[line.key] === undefined ? line.quantity : updates[line.key]) > 0);
    let paidBoxLeft = state.boxEnabled && paidCount > 0 && !freeBoxPresent ? 1 : 0;
    for (const line of lines.filter(line => String(line.variant) === String(state.paidBox))) {
      const wanted = Math.min(line.quantity, paidBoxLeft);
      paidBoxLeft -= wanted;
      if (wanted !== line.quantity) updates[line.key] = wanted;
    }
    return { paidCount, boxAllowed, updates, missingGifts };
  }
  return { evaluate };
});

(function () {
  'use strict';
  if (window.__tobariCommerce) return;
  window.__tobariCommerce = true;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const route = path => root + path;
  let busy = false;
  let lastOpener = null;
  let freeBoxJustAdded = false;
  let giftJustAdded = false;
  const blockedGifts = new Set();
  let checkoutRetryAllowed = false;
  async function request(path, body) {
    const response = await fetch(route(path), body === undefined ? { headers: { Accept: 'application/json' } } : {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    });
    const result = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'We couldn’t update your cart. Please try again.');
    return result;
  }
  async function snapshot() {
    const response = await fetch(route('cart') + '?tb_refresh=' + Date.now(), { cache: 'no-store', headers: { Accept: 'text/html' } });
    if (!response.ok) throw new Error('We couldn’t refresh your cart. Please reload before checking out.');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const node = doc.querySelector('[data-tb-cart]');
    if (!node) throw new Error('The new Tobari cart section is missing. Please reload or contact us.');
    const state = JSON.parse(node.querySelector('[data-tb-cart-state]').textContent);
    return { node, state };
  }
  function render(view) {
    const current = document.querySelector('[data-tb-cart]');
    if (current) current.replaceWith(view.node);
    document.dispatchEvent(new CustomEvent('tobari:cart:rendered', { detail: { state: view.state } }));
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = view.state.count > 99 ? '99+' : String(view.state.count);
      el.style.display = view.state.count > 0 ? 'grid' : 'none';
    });
  }
  function message(text, card) {
    const target = document.querySelector('[data-tb-cart-status]') || (card && card.querySelector('[data-tb-card-status]')) || document.querySelector('[data-tb-page-status]');
    if (target) target.textContent = text;
  }
  function lock(value) {
    document.querySelectorAll('[data-tb-cart] button, [data-tb-bundle-add], [data-tb-box-add]').forEach(button => {
      if (value) { button.dataset.tbWasDisabled = button.disabled ? 'true' : 'false'; button.disabled = true; }
      else if (button.dataset.tbWasDisabled !== undefined) { button.disabled = button.dataset.tbWasDisabled === 'true'; delete button.dataset.tbWasDisabled; }
    });
    document.querySelector('[data-tb-cart]')?.setAttribute('aria-busy', String(value));
  }

async function reconcile(view) {
  // Reconcile existing promotional items and the earned premium box.
  for (let attempt = 0; attempt < 5; attempt++) {
    const rule = window.TobariOfferRules.evaluate(view.state);
    const updates = rule.updates;

    if (Object.keys(updates).length > 0) {
      await request('cart/update.js', { updates });
      view = await snapshot();
      continue;
    }

    const freeBoxPresent = view.state.lines.some(line =>
      String(line.variant) === String(view.state.freeBox) &&
      line.quantity > 0 &&
      line.price === 0
    );

    rule.missingGifts = (rule.missingGifts || []).filter(item => !blockedGifts.has(item.id));
    if (rule.missingGifts && rule.missingGifts.length) {
      // Add earned bundle gifts one by one so a sold-out gift never blocks the others.
      let added = 0;
      for (const item of rule.missingGifts) {
        if (blockedGifts.has(item.id)) continue;
        try { await request('cart/add.js', { items: [item] }); added++; } catch (_) { blockedGifts.add(item.id); /* gift sold out: skip */ }
      }
      view = await snapshot();
      // A gift that is not £0 in the cart (no price set to £0 and no discount) is never forced on the customer.
      view.state.lines.forEach(line => { if (/^b\d+$/.test(String(line.gift || '')) && Number(line.price) > 0) blockedGifts.add(Number(line.variant)); });
      if (added) { giftJustAdded = true; continue; }
      return view;
    }

    if (rule.boxAllowed && !freeBoxPresent) {
      const id = Number(view.state.freeBox);

      if (!Number.isSafeInteger(id) || id <= 0) {
        throw new Error('Free premium box is not configured.');
      }

      view = await addItems([{
        id: id,
        quantity: 1,
        properties: { _tobari_offer: 'packaging' }
      }]);
      freeBoxJustAdded = true;

      continue;
    }

    return view;
  }

  throw new Error(
    'Your gift eligibility changed. Please reload your cart before checkout.'
  );
}

  async function run(action, card, navigate) {
    if (busy) return;
    busy = true;
    lock(true);
    freeBoxJustAdded = false;
    giftJustAdded = false;
    try {
      const result = await action();
      const view = await reconcile(result || await snapshot());
      render(view);
      if (navigate && !document.querySelector('[data-tb-cart-form]')) window.location.assign(route('cart'));
      else message(giftJustAdded ? 'Bundle unlocked! Your free gift has been added ✦' : freeBoxJustAdded ? 'Your free premium gift box has been added ✦' : 'Cart updated. Your displayed prices are current.', card);
    } catch (error) {
      try { render(await snapshot()); } catch (_) { /* Keep the current cart and the error. */ }
      message(error.message || 'Please refresh your cart and try again.', card);
    } finally { busy = false; lock(false); }
  }
  async function addItems(items) {
    const giftKeys = items.map(item => item.properties && item.properties._tobari_offer).filter(Boolean);
    await request('cart/add.js', { items });
    let view = await snapshot();
    const unpaidGifts = view.state.lines.filter(line => giftKeys.includes(line.gift) && line.price > 0);
    if (unpaidGifts.length) {
      const updates = Object.fromEntries(unpaidGifts.map(line => [line.key, 0]));
      await request('cart/update.js', { updates });
      throw new Error('The free-gift discount did not apply, so we removed the gift to avoid charging you. Your paid hijabs remain in the cart. Please contact us for help.');
    }
    return view;
  }
  document.addEventListener('click', function (event) {
    const open = event.target.closest('[data-tb-rewards-open]');
    if (open) { lastOpener = open; document.getElementById('tobari-rewards-dialog')?.showModal(); return; }
    if (event.target.closest('[data-tb-rewards-close]')) { document.getElementById('tobari-rewards-dialog')?.close(); return; }
    const more = event.target.closest('[data-tb-more-offers]');
    if (more) { more.closest('.tb-bundles').querySelectorAll('[data-tb-extra-offer]').forEach(el => { el.hidden = false; }); more.hidden = true; return; }
    const change = event.target.closest('[data-tb-cart-change]');
    if (change) {
      event.preventDefault();
      run(async () => { await request('cart/change.js', { id: change.dataset.key, quantity: Number(change.dataset.quantity) }); });
      return;
    }
    // Tobari cart rewards: "add one more hijab" quick add.
    const quick = event.target.closest('[data-tb-quick-add]');
    if (quick) {
      event.preventDefault();
      const quickId = Number(quick.dataset.variantId);
      if (!Number.isSafeInteger(quickId) || quickId <= 0 || busy) return;
      quick.classList.add('is-adding');
      quick.textContent = 'Adding…';
      run(async () => addItems([{ id: quickId, quantity: 1 }]), null, true);
      return;
    }
    // Tobari bundles: add the missing hijab(s); earned gifts are added by reconcile().
    const pair = event.target.closest('[data-tb-pair-add]');
    if (pair) {
      event.preventDefault();
      if (busy) return;
      const card = pair.closest('[data-tb-bundle-card]');
      const ids = String(pair.dataset.variantIds || '').split(',').map(Number).filter(id => Number.isSafeInteger(id) && id > 0);
      if (!ids.length) return;
      const label = pair.getAttribute('data-default-label') || 'Add';
      pair.textContent = 'Adding…';
      const onCart = !!document.querySelector('[data-tb-cart-form]') || !!pair.closest('[data-tb-cart]');
      run(async () => addItems(ids.map(id => ({ id, quantity: 1 }))), card, !onCart)
        .finally(() => { if (document.body.contains(pair)) pair.textContent = label; });
      return;
    }
const bundle = event.target.closest('[data-tb-bundle-add]');

if (bundle) {
  event.preventDefault();

  const card = bundle.closest('[data-tb-bundle-card]');

  if (!card) return;

  // Returning customers: skip the hijab they already own (Bundles page sets this).
  const ownedVariants = String(card.getAttribute('data-tb-owned-variants') || '');
  const selects = [
    ...card.querySelectorAll('[data-tb-bundle-variant]')
  ].filter(select => !ownedVariants.includes(',' + select.value + ','));

  const inCart = !!bundle.closest('[data-tb-cart]');
  const items = selects.map(select => (inCart && select.dataset.tbGift ? {
    id: Number(select.value),
    quantity: 1,
    properties: { _tobari_offer: select.dataset.tbGift }
  } : {
    id: Number(select.value),
    quantity: 1
  }));

  if (
    !items.length ||
    items.some(item => !Number.isSafeInteger(item.id) || item.id <= 0) ||
    selects.some(
      select =>
        select.disabled ||
        !select.selectedOptions.length ||
        select.selectedOptions[0].disabled
    )
  ) {
    message('Please choose an available option.', card);
    return;
  }

  const discountCode =
    (card.getAttribute('data-tb-discount-code') || '').trim();

  const defaultLabel =
    bundle.getAttribute('data-default-label') ||
    bundle.textContent.trim() ||
    'Add bundle';

  bundle.classList.remove('is-added');
  bundle.classList.add('is-adding');
  bundle.textContent = 'Adding…';

  run(
    async () => {
      const view = await addItems(items);

      bundle.classList.remove('is-adding');
      bundle.classList.add('is-added');
      bundle.textContent = '✓ Added';

      message('Bundle added to your cart.', card);

      await new Promise(resolve => {
        window.setTimeout(resolve, 750);
      });

      if (discountCode) {
        window.location.assign(
          route('discount/' + encodeURIComponent(discountCode)) +
          '?redirect=' +
          encodeURIComponent(route('cart'))
        );
      } else {
        window.location.assign(route('cart'));
      }

      return view;
    },
    card,
    false
  ).finally(() => {
    if (!bundle.classList.contains('is-added')) {
      bundle.classList.remove('is-adding');
      bundle.textContent = defaultLabel;
    }
  });

  return;
}
    const box = event.target.closest('[data-tb-box-add]');
    if (box) {
      event.preventDefault();
      run(async () => {
        const view = await snapshot();
        const rule = window.TobariOfferRules.evaluate(view.state);
        const isFree = box.dataset.free === 'true';
        if ((isFree && !rule.boxAllowed) || rule.paidCount === 0) throw new Error('Add qualifying paid hijabs before adding this packaging.');
        const id = Number(isFree ? view.state.freeBox : view.state.paidBox);
        return addItems([{ id, quantity: 1, ...(isFree ? { properties: { _tobari_offer: 'packaging' } } : {}) }]);
      }, null, true);
    }
  });
  document.addEventListener('submit', function (event) {
    const form = event.target.closest('[data-tb-cart-form]');
    if (!form) return;
    event.preventDefault();
    if (busy) return;
    if (checkoutRetryAllowed) { window.location.assign(route('checkout')); return; }
    busy = true; lock(true);
    (async () => {
      const before = await snapshot();
      const needsUpdate = Object.keys(window.TobariOfferRules.evaluate(before.state).updates).length > 0;
      const view = await reconcile(before);
      render(view);
      if (needsUpdate) message('Your gift eligibility changed. Please review the updated cart, then proceed to checkout.');
      else if (view.state.count > 0) window.location.assign(route('checkout'));
    })().catch(async error => {
      // A free gift that could not be added must never trap a paying customer:
      // show what happened once, then the next checkout click goes straight through.
      try { render(await snapshot()); } catch (_) { /* keep the current cart */ }
      checkoutRetryAllowed = true;
      message((error.message || 'We couldn’t update your free gift.') + ' You can continue to checkout.');
    }).finally(() => { busy = false; lock(false); });
  });
  const dialog = document.getElementById('tobari-rewards-dialog');
  dialog?.addEventListener('close', () => lastOpener?.focus());
  dialog?.addEventListener('click', event => {
    const rect = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
  });

  // Reconcile promotional items and automatically add earned packaging.
  if (document.querySelector('[data-tb-cart]')) {
    const initial = JSON.parse(
      document.querySelector('[data-tb-cart-state]').textContent
    );

    const rule = window.TobariOfferRules.evaluate(initial);

    const freeBoxPresent = initial.lines.some(line =>
      String(line.variant) === String(initial.freeBox) &&
      line.quantity > 0 &&
      line.price === 0
    );

    if (
      Object.keys(rule.updates).length > 0 ||
      (rule.missingGifts && rule.missingGifts.length > 0) ||
      (rule.boxAllowed && !freeBoxPresent)
    ) {
      run(async () => snapshot());
    }
  }

})();
